import React from 'react'
import styled from 'styled-components'
// import Img from 'gatsby-image'

export const LEFT = props => {
    return ( 
        <BlurbLeft>
            <div className="flex-container">
                <img src={props.icon} alt=""/>
                <div className="blurb-content">{props.content}</div>
            </div>
        </BlurbLeft>
    )
}

export const UP = props => {
    return ( 
        <BlurbUp>
            <div className="flex-container">
                <img src={props.icon} alt=""/>
                <div className="blurb-content">{props.content}</div>
            </div>
        </BlurbUp>
    )
}

const BlurbLeft = styled.div`
    display: inline-flex;
    width: 48%;
    .flex-container{
        display: flex;
        flex-wrap: nowrap;
    }
    img{
        width: 50px;
        height: 50px;
        margin: 0 auto;
    }
    .blurb-content{
        margin-left: 30px;
    }
`

const BlurbUp = styled.div`
    display: inline-flex;
    width: 48%;
    .flex-container{

    }
    img{
        width: 50px;
        height: 50px;
        margin: 0 auto;
        display: block;
    }
    .blurb-content{
        margin-left: 30px;
    }
`

